import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme();

theme.typography.h5 = {
  fontSize: "18px",
  "@media (min-width:600px)": {
    fontSize: "21px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "21px",
  },
};
theme.typography.body1 = {
  fontSize: "16px",
  "@media (min-width:600px)": {
    fontSize: "18px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "18px",
  },
};

const BlogsCard = ({ blog, isLoading }) => {
  const url = `/blog/${blog?._id}`;
  // console.log(blog)
  return (
    <Grid item xs={4} sm={4} md={4}>
      {isLoading && <CircularProgress />}
      <Link to={url}>
        {" "}
        <ThemeProvider theme={theme}>
          <Card
            className="CardBG customboxshadow"
            sx={{ boxShadow: 4, borderRadius: 3, py: 2 }}
          >
            <CardMedia
              height="220px"
              width="100%"
              component="img"
              sx={{ mx: "auto" }}
              image={blog?.image}
              alt="green iguana"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ py: 2 }}
                className="cardtextwhite"
              >
                {blog?.name}
              </Typography>
              <Typography
                variant="body1"
                color="text.primary"
                className="cardtextwhite"
              >
                {blog?.description.slice(0, 120)}{" "}
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to={url}
                >
                  <Button>Read More+</Button>
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </ThemeProvider>
      </Link>
    </Grid>
  );
};

export default BlogsCard;
